

$('.navi .sub a').click(function(e) {

    var url = $(this).attr('href');
    var hash = url.substring(url.indexOf('#')).substring(1);
    var target = $('.menupunkt[anchor='+hash+']');

    $([document.documentElement, document.body]).animate({
        scrollTop: target.offset().top - $('header').height() +5
    },500);

});


$('.button a.link').click(function(e) {

    var url = $(this).attr('href');
    var hash = url.substring(url.indexOf('#')).substring(1);
    var target = $('.menupunkt[anchor='+hash+']');

    $([document.documentElement, document.body]).animate({
        scrollTop: target.offset().top - $('header').height() +5
    },500);

});


$('a.link').click(function(e) {

    e.preventDefault();
    var url = $(this).attr('href');
    var hash = url.substring(url.indexOf('#')).substring(1);
    var target = $('.menupunkt[anchor='+hash+']');

    $([document.documentElement, document.body]).animate({
        scrollTop: target.offset().top - $('header').height() +5
    },500);

});



$(document).ready(function() {
    if(window.location.hash) {

        var hash = window.location.hash.substring(1);
        var target = $('.menupunkt[anchor='+hash+']');

        $([document.documentElement, document.body]).animate({
            scrollTop: target.offset().top - $('header').height() +5
        },0);

    }
});



